export class INSPECTIONS_TYPES_IDS {
  public static THICKNESS_GAUGING = 'd504da80-1ae9-4aa1-b6e1-312149bc1a24'
}
